<template>
  <el-table :data="currentValue" style="width: 100%">
    <el-table-column :label="$t('common.finishType')" width="120">
      <template slot-scope="scope">
        <span>{{ scope.row['finishFinishTypeDescription'] }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('common.finish')" width="180">
      <template slot-scope="scope">
        <span>{{ scope.row | finishFilter }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('orderLine.product')" width="120">
      <template slot-scope="scope">
        <span>{{ scope.row['productDescription'] }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('orderLine.amount')" width="90">
      <template slot-scope="scope">
        <span>{{ scope.row | productQuantityFilter }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { ConvertMillimetersToCentimeters } from '@/utils/converters';
export default {
  filters: {
    finishFilter(row) {
      let value = row.finishDescription;
      if (row.measurementInMm) {
        const valueInCm = ConvertMillimetersToCentimeters(row.measurementInMm);
        value += ` ${valueInCm}cm`;
      }
      return value;
    },
    productQuantityFilter(row) {
      let value = '';
      if (row.quantityLeft && row.quantityRight) {
        value += ` ${row.quantityLeft + row.quantityRight} (L${row.quantityLeft} R${row.quantityRight})`;
      } else if (row.quantityLeft) {
        value += ` ${row.quantityLeft}`;
      } else if (row.quantityRight) {
        value += ` ${row.quantityRight}`;
      }
      return value;
    }
  },
  props: {
    value: Array
  },
  data: () => ({
    currentValue: []
  }),
  watch: {
    value(value) {
      // Hide specials, since they are already presented elsewhere.
      this.currentValue = value && value.filter(orderLineDetail => !orderLineDetail.specialID);
    }
  }
};
</script>

<style lang="scss" scoped></style>
